import * as React from 'react';
import { Switch, Route } from 'react-router';
import { WorkList } from './WorkList';
import { UserContext } from '../Common/UserContext';
import { ActiveWork } from './ActiveWork';

export class Calling extends React.Component<{}, {}> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <UserContext>
        <Switch>
          <Route path='/dashboard/start_calling/active' component={ActiveWork} />
          <Route exact path='/dashboard/start_calling' component={WorkList} />
        </Switch>
      </UserContext>
    );
  }
}
